namespace GeniuzPOS.ReportMasterData {
    export interface Report_1320Row {
        Id?: string;
        PromoId?: string;
        PromoName?: string;
        PromoDesc?: string;
        PromoCampaign?: string;
        PluCode?: string;
        PluDesc?: string;
        PluShortDesc?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        Qty?: number;
        BasePrice?: number;
        PromoDics?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1320Row {
        export const idProperty = 'Id';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'ReportMasterData.Report_1320';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            PromoId = "PromoId",
            PromoName = "PromoName",
            PromoDesc = "PromoDesc",
            PromoCampaign = "PromoCampaign",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PluShortDesc = "PluShortDesc",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            Qty = "Qty",
            BasePrice = "BasePrice",
            PromoDics = "PromoDics",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
